export default {
    topics: [
        {
            title: ' JavaScript exceptions ',
            href: 'p-4.html',
            attributes: { 'data-id': 'p-4' },
            menu: { hasChildren: false },
            tocID: 'p-4-d66e29',
            topics: [],
        },
        {
            title: ' Using dates ',
            href: 'p-5.html',
            attributes: { 'data-id': 'p-5' },
            menu: { hasChildren: false },
            tocID: 'p-5-d66e37',
            topics: [],
        },
        {
            title: ' Using XML ',
            href: 'p-6.html',
            attributes: { 'data-id': 'p-6' },
            menu: { hasChildren: false },
            tocID: 'p-6-d66e45',
            topics: [],
        },
        {
            title: ' E4X Migration guide ',
            href: 'p-7.html',
            attributes: { 'data-id': 'p-7' },
            menu: { hasChildren: false },
            tocID: 'p-7-d66e53',
            topics: [],
        },
        {
            title: ' Data protection: escaping functions ',
            href: 'p-8.html',
            attributes: { 'data-id': 'p-8' },
            menu: { hasChildren: false },
            tocID: 'p-8-d66e61',
            topics: [],
        },
    ],
};

